import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 10 10',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M5,5.94 L2,3 C1.71319355,2.86302346 1.37119148,2.92170174 1.14644661,3.14644661 C0.921701738,3.37119148 0.86302346,3.71319355 1,4 L4.5,7.5 C4.79281755,7.79245338 5.26718245,7.79245338 5.56,7.5 L9,4 C9.13697654,3.71319355 9.07829826,3.37119148 8.85355339,3.14644661 C8.62880852,2.92170174 8.28680645,2.86302346 8,3 L5,5.94 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);
export default SVG;
